import { render, staticRenderFns } from "./PopularMovies.vue?vue&type=template&id=68b90976&scoped=true&"
import script from "./PopularMovies.vue?vue&type=script&lang=js&"
export * from "./PopularMovies.vue?vue&type=script&lang=js&"
import style0 from "./PopularMovies.vue?vue&type=style&index=0&id=68b90976&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b90976",
  null
  
)

export default component.exports